import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type MoneyInputProps = Omit<
  NumericFormatProps<OutlinedInputProps>,
  'customInput'
>;

export function MoneyInput(props: MoneyInputProps) {
  return <NumericFormat {...props} customInput={OutlinedInput} />;
}
